import { transient } from "aurelia-dependency-injection";
import mappings from './system-error-mappings.json';

@transient()
export class SystemErrorValueConverter {

    public toView(systemError: string): string {
        if (systemError) {
            let readableError = 'System Error';
            
            for(const pattern in mappings){
                const regex = new RegExp(pattern,'gmi');
                if(regex.test(systemError))
                {
                    readableError = mappings[pattern];
                    break;
                }
            }

            return  `(${readableError})`;
        }
        return '';
    }
}